<template>
  <div class="">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'JifenIndex',
  components: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  mounted () {},
  methods: {}
}
</script>
<style lang="scss" scoped>

</style>
